import React from "react";
import { NavLink } from "react-router-dom";
import NavItemHeader from "./Sidebar/NavItemHeader";
import { LayoutState } from "../Context/LayoutContext/LayoutContext";
import { useTranslation } from 'react-i18next';

const NavItem = ({ item, index = "" }) => {
  const { collapsed } = LayoutState();
  const { to, icon, label, children } = item;
  const { t } = useTranslation();
  
  // Fix for proper translation - ensure we handle label correctly
  const translatedLabel = typeof label === 'string' ? t(label) : label;
  
  // Use NavItemHeader for items with children
  if (children && children.length > 0) {
    return <NavItemHeader item={item} />;
  }

  // Check if "to" is empty to determine if we should apply active styling
  const hasValidPath = to && to.trim() !== "";
  
  // Render simple NavItem for items without children
  return (
    <li className="nav__item" key={index}>
      <NavLink
        to={to || "#"}
        className={({ isActive }) =>
          (isActive && hasValidPath)
            ? `nav__link ${!collapsed ? "nav__active" : "nav__active--collapsed"}`
            : "nav__link "
        }
        title={collapsed ? translatedLabel : ""} // Tooltip only when collapsed
      >
        <span className="nav-icon">{icon}</span>
        {!collapsed && translatedLabel}
      </NavLink>
    </li>
  );
};

export default NavItem;